var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStores = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16.242 4.758Q14.484 3 12 3T7.758 4.758 6 9q0 1.277.387 2.098l4.277 9.07q.176.386.545.61a1.51 1.51 0 0 0 1.582-.001 1.4 1.4 0 0 0 .557-.609l4.265-9.07Q18 10.277 18 9q0-2.484-1.758-4.242m-2.121 6.363A2.9 2.9 0 0 1 12 12a2.9 2.9 0 0 1-2.121-.879A2.9 2.9 0 0 1 8.999 9q0-1.242.88-2.121a2.9 2.9 0 0 1 2.12-.88 2.9 2.9 0 0 1 2.122.88A2.9 2.9 0 0 1 15 8.999a2.9 2.9 0 0 1-.88 2.122z",
  clipRule: "evenodd"
})));
export default SvgStores;